import * as React from 'react'

import { CircularProgress, Typography } from '@material-ui/core'

import './style.scss'

interface INativeProps {
  text?: string
}
interface IProps extends INativeProps {}

interface IState {
  dots: number
}

export class DefaultLoader extends React.Component<IProps, IState> {
  private static maxDots = 3
  private static minDots = 1

  state: IState = {
    dots: DefaultLoader.minDots
  }

  private interval: number

  componentDidMount() {
    this.interval = window.setInterval(this.updateDots, 1000)
  }

  componentWillUnmount() {
    window.clearInterval(this.interval)
  }

  updateDots = () => {
    this.setState(prevState => ({
      dots:
        prevState.dots === DefaultLoader.maxDots
          ? DefaultLoader.minDots
          : prevState.dots + 1
    }))
  }

  getDots = () => <span className="dots">{'.'.repeat(this.state.dots)}</span>

  render() {
    const { text } = this.props
    return (
      <div className="default-loader">
        <Typography className="loading">
          {text || 'Loading'}
          {this.getDots()}
        </Typography>
        <CircularProgress className="loading-icon" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Loader/DefaultLoader/index.tsx